export const colorFormat = {
  Purple: '#590aa3',
  Blue: '#1b82ec',
  LightPurple: '#f7e6ff',
  Red_Light: '#FFEAEA',
  Red_Dark: '#dc2626',
  Green: '#16a34a',
  FilterBlueImage:
    'invert(39%) sepia(94%) saturate(861%) hue-rotate(183deg) brightness(91%) contrast(104%)',
  Dark_Blue: '#00035B',
  Black: '#000000',
  Yellow: '#ca8a04'
};
